import { Avatar, Box, Divider, Grid2 as Grid, ListItemText, Stack, Tab, Tabs, Typography } from "@mui/material"
import { handleRetrieveSpecialistDetails } from "../../../../../redux/member-slices/bookedSpecialists.slice"
import TabPanel from "../../../../../components/common/TabPanel"
import { FILE_PATH_URI } from "../../../../../utils/helper"
import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import Appointments from "./appointments"
import Documents from "./documents"

function Single() {
  const dispatch = useDispatch()
  const { id: specialistId } = useParams()
  const [data, setData] = useState({})
  const [activeTab, setActiveTab] = useState("appointments")
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  // --------------- Get all appointments ---------------
  const handleRetrieveAll = async (filters) => {

    const response = await dispatch(
      handleRetrieveSpecialistDetails({
        specialistId,
        limit: 10,
        date: filters?.date || null,
        timeZone: userTimeZone || null,
        currentPage: filters?.currentPage || null,
      })
    ).unwrap() || {}
    if (response?.specialistInfo)
      setData(response)
  }

  // --------------- Handle tab switch ---------------
  const handleTabChange = (_, value) => { setActiveTab(value) }

  useEffect(() => {
    handleRetrieveAll()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Grid container spacing={3}>
        <Grid size={12}>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            divider={<Divider flexItem sx={{ borderWidth: "thin" }} />}
          >
            <Avatar
              sx={{ width: 50, height: 50 }}
              src={FILE_PATH_URI + data?.specialistInfo?.profilePhoto}
            />
            <ListItemText
              primary={data?.specialistInfo?.name || ""}
              secondary={
                <Typography>
                  <Typography component="span" fontWeight="500">Experience : </Typography>
                  {data?.specialistInfo?.experience || "N/A"} {Boolean(data?.specialistInfo?.experience) && "Year(s)"}
                </Typography>
              }
              slotProps={{
                secondary: {
                  style: { fontSize: 16, textTransform: "capitalize" },
                },
                primary: {
                  style: {
                    fontSize: 20,
                    fontWeight: "500",
                    textTransform: "capitalize",
                  },
                },
              }}
            />
            <ListItemText
              slotProps={{
                primary: {
                  style: { fontSize: 16, textTransform: "capitalize" },
                },
                secondary: {
                  style: { fontSize: 16, textTransform: "capitalize" },
                },
              }}
              secondary={
                <Typography>
                  <b>Specialization : </b>
                  {data?.specialistInfo?.specializationName || "N/A"}
                </Typography>
              }
              primary={
                <Box display="flex" gap={0.5}>
                  <Typography fontWeight={600}>Age :</Typography>
                  <Typography fontWeight={400}>
                    {data?.specialistInfo?.age || "N/A"} {Boolean(data?.specialistInfo?.age) && "Year(s)"}
                  </Typography>
                </Box>
              }
            />
          </Stack>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid size={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab value="appointments" label="Appointments" />
              <Tab value="documents" label="Documents" />
            </Tabs>
          </Box>
        </Grid>
      </Grid>

      <TabPanel value={activeTab} index="appointments">
        <Appointments data={data} handleRetrieveAll={handleRetrieveAll} />
      </TabPanel>

      <TabPanel value={activeTab} index="documents">
        <Documents specialistId={specialistId} />
      </TabPanel>
    </>
  )
}

export default Single